import React from "react";
import "../HomeWhyChoose.css";
import { Link } from "react-router-dom";

import {
  FiShield,
  FiFileText,
  FiCloud,
  FiZap,
  FiUsers,
  FiTrendingUp,
  FiArrowRight,
  FiCheckCircle,
} from "react-icons/fi";

const features = [
  {
    icon: <FiShield />,
    title: "Enterprise Security",
    description:
      "Bank-grade security architecture designed to safeguard financial data, digital assets, and customer information with advanced protection.",
  },
  {
    icon: <FiFileText />,
    title: "Regulatory Compliance",
    description:
      "Solutions aligned with AML, KYC, RBI, FATF, and global compliance standards to reduce regulatory risk and improve governance.",
  },
  {
    icon: <FiZap />,
    title: "Fast API Integration",
    description:
      "Seamlessly integrate with banking systems, payment gateways, fintech platforms, and third-party financial services.",
  },
  {
    icon: <FiCloud />,
    title: "Cloud-Native Solutions",
    description:
      "Scalable cloud infrastructure built for high availability, reliability, business continuity, and long-term growth.",
  },
  {
    icon: <FiUsers />,
    title: "Dedicated Experts",
    description:
      "Experienced fintech professionals delivering consulting, implementation, and ongoing support tailored to your business.",
  },
  {
    icon: <FiTrendingUp />,
    title: "Future-Ready Innovation",
    description:
      "Leverage AI automation, intelligent analytics, and emerging technologies to stay competitive in the evolving fintech ecosystem.",
  },
];

const HomeWhyChoose = () => {
  return (
    <section className="why-choose">

      <div className="container">

        {/*=========================
              LEFT SIDE
        =========================*/}

        <div className="why-left">

          <span className="why-tag">
            WHY CHOOSE SAIVARI
          </span>

          <h2>
            Why Financial Institutions
            <span> Trust Saivari Fintech</span>
          </h2>

          <p>
            Saivari Fintech Private Limited combines technology,
            compliance expertise, and industry knowledge to help
            banks, NBFCs, payment providers, and fintech companies
            accelerate digital transformation with confidence.
          </p>

          {/* Dashboard */}

          <div className="security-dashboard">

            <div className="dashboard-header">

              <h4>Security & Compliance</h4>

              <span className="live-status">
                ● Live
              </span>

            </div>

            <div className="dashboard-grid">

              <div className="dashboard-box">
                <h3>99.9%</h3>
                <span>Platform Security</span>
              </div>

              <div className="dashboard-box">
                <h3>24×7</h3>
                <span>Monitoring</span>
              </div>

              <div className="dashboard-box">
                <h3>100%</h3>
                <span>Compliance</span>
              </div>

              <div className="dashboard-box">
                <h3>AI</h3>
                <span>Automation</span>
              </div>

            </div>

            {/* Floating Cards */}

            {/* <div className="floating security">
              🛡 Enterprise Security
            </div>

            <div className="floating cloud">
              ☁ Cloud Infrastructure
            </div>

            <div className="floating api">
              ⚡ API Connected
            </div> */}

          </div>

        </div>

        {/*=========================
              RIGHT SIDE
        =========================*/}

        <div className="home-why-right">

          <div className="home-why-grid">

            {features.map((item, index) => (

              <div
                className="home-why-card"
                key={index}
              >

                <div className="home-why-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.description}</p>

              </div>

            ))}

          </div>

          {/* Trust Row */}

          <div className="why-trust">

            <div>
              <FiCheckCircle />
              <span>Trusted Technology</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>Scalable Solutions</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>Industry Expertise</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>24×7 Support</span>
            </div>

          </div>

          <a
            href="/contact"
            className="why-btn"
          >
            Schedule Consultation
            <FiArrowRight />
          </a>

        </div>

      </div>

    </section>
  );
};

export default HomeWhyChoose;